// Persistent store for models' BAKED RENDER ASSETS (the Layout-placement
// geometry), kept in its OWN IndexedDB database so it never bloats the model
// list. The asset is a regenerable cache keyed by model id — dropping it just
// means the next placement re-bakes. Separating it is what keeps listModels()
// (the save name-collision check + the dock) light: those deserialize whole
// model records, and the Float32 geometry buffers had made that slow.

import type { BakedAssetCore } from "./saved-model";
import { createScopedStore } from "../sync/account-scope";

// One per model. `updatedAt` mirrors the model revision the bake was built from;
// placement trusts the bake only when bake.updatedAt === model.updatedAt.
export type BakeRecord = { id: string; updatedAt: number } & BakedAssetCore;

// Scoped per account like the model library it caches for (a bake renders the
// model, so it must not outlive a sign-out either). Claimed models leave their
// anonymous-pool bake behind as harmless regenerable garbage.
const store = createScopedStore<BakeRecord>("tinydraft-bakes", "bakes");

export function getBake(id: string): Promise<BakeRecord | undefined> {
  return store.get(id);
}
export function putBake(rec: BakeRecord): Promise<IDBValidKey> {
  return store.put(rec);
}
export function deleteBake(id: string): Promise<undefined> {
  return store.remove(id);
}
